#root {
  box-sizing: border-box; /* Ensure padding is included in width */
  width: 100%;
  max-width: 100%; /* Allow it to grow to full width */
  margin: 0 auto;
  padding: 1rem; /* Reduced padding */
  height:100%;
}

.app-container {
  display:flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box; /* Ensure padding is included in width */
  overflow: hidden;
  background-color: white;
  padding: 0.5rem;
  border-radius: 0.5rem;
  box-shadow: var(--shadow);
  /* Ensure the app-container doesn't exceed the width of #root */
  width: 100%;
  max-width: 100%; /* Allow it to grow to full width */
  margin: 0 auto;
}

h1 {
  color: var(--primary);
  margin-bottom: 2rem;
}

/* Remove padding on mobile */
@media (max-width: 767px) {
  #root {
    padding: 0;
  }
  .app-container {
    padding: 0;
  }
}